

import WRoute from './Routes/root.js';
import './App.css';
function App() {
  return (
    <>
      <WRoute />
    </>
  );
}

export default App;
